// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAcGVgnwnhwM9RiFRtex7TPEon0WErrrxE",
  authDomain: "gotelecom-nft.firebaseapp.com",
  projectId: "gotelecom-nft",
  storageBucket: "gotelecom-nft.appspot.com",
  messagingSenderId: "23329762161",
  appId: "1:23329762161:web:e9f1260baf1dd5bb83e4d0",
  measurementId: "G-VLLJZWLQYN"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);